export default "__VITE_ASSET__c7d2e8a6__"